import Stats from 'stats.js';

export interface DebugStats {
  dom: HTMLElement;
  update: () => void;
}

export function createStats(): DebugStats {
  const stats = new Stats();
  stats.dom.style.position = 'fixed';
  stats.dom.style.top = '';
  stats.dom.style.left = '0';
  stats.dom.style.right = '';
  stats.dom.style.bottom = '0';
  return stats;
}
